// extracted by mini-css-extract-plugin
export default {"back":"Cart_back__sKGev","container":"Cart_container__EuZXh","header":"Cart_header__XJxcM","main":"Cart_main__-3q-A","bottom":"Cart_bottom__j4heJ","btn":"Cart_btn__Hw7c8"};